import type { ReactNode } from 'react';
import { Body1Strong, Caption1, Card, CardHeader, makeStyles, tokens } from '@fluentui/react-components';

const useStyles = makeStyles({
  header: {
    paddingBottom: tokens.spacingVerticalS,
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    gap: tokens.spacingVerticalM,
  },
  description: {
    color: tokens.colorNeutralForeground3,
  },
});

interface SectionCardProps {
  title: string;
  description?: string;
  action?: ReactNode;
  children: ReactNode;
  /** Optional extra class on the Card root (e.g. a status accent border). */
  className?: string;
}

export function SectionCard({ action, children, description, title, className }: SectionCardProps) {
  const styles = useStyles();

  return (
    <Card size="large" className={className}>
      <CardHeader
        className={styles.header}
        header={<Body1Strong>{title}</Body1Strong>}
        description={description ? <Caption1 className={styles.description}>{description}</Caption1> : undefined}
        action={action ? <div>{action}</div> : undefined}
      />
      <div className={styles.content}>{children}</div>
    </Card>
  );
}
